import { AnalyticsStore } from "bernie-plugin-mobx";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { TripCostEstimatorHotelCost } from "../typings";
import { LocalizedComponentProps } from "@shared-ui/localization-context";

export interface ParamsSetChartBehaviour {
  lineSvg: SVGLineElement;
  index: number;
  barItemReferred: TripCostEstimatorHotelCost;
  handlePopoverClick: () => void;
}

export interface PopoverPropsCreator {
  containerWidth: number;
  x: number;
  y: number;
  item: TripCostEstimatorHotelCost;
  linkAction: () => void;
}

export interface ChartDrawData {
  index: number;
  type: string;
  seriesIndex: number;
  element: {
    _node: SVGLineElement;
    addClass: (names: string) => void;
  };
}

export interface MonthChartProps extends LocalizedComponentProps {
  id: string;
  data: TripCostEstimatorHotelCost[];
  onClick: (hotelCost?: TripCostEstimatorHotelCost) => void;
  handleRenderedGraph: (popover: { closePopover: () => void }) => void;
  low?: number;
  high?: number;
  analytics?: AnalyticsStore;
  context?: ExtendedContextStore;
  showPopover: boolean;
  isMobile: boolean;
}

export interface NavigatorProps {
  currentSlide: number;
  monthRange: string;
  onChange: (isRightArrow: boolean) => (e: MouseEvent) => void;
  shouldShowNavigation: boolean;
}

export interface ArrowLinkProps {
  disabled: boolean;
  direction: string;
  onClick: (isLeftArrow: boolean) => (e: MouseEvent) => void;
}

export enum ARROW_LINK_DIRECTION {
  LEFT = "left",
  RIGHT = "right",
}
